/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLayoutColumns = createReactComponent("layout-columns", "IconLayoutColumns", [
  [
    "path",
    {
      d: "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M12 4l0 16", key: "svg-1" }]
]);

export { IconLayoutColumns as default };
//# sourceMappingURL=IconLayoutColumns.js.map
